import React from "react";
import { Redirect, Route, withRouter } from "react-router-dom";
import routes from "./../../config/app-route.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import {
  isFreelanceRouteAllowed,
  isFreelanceUser,
} from "../../utils/freelance-access.js";

function setTitle(path, routeArray) {
  var appTitle;
  for (var i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      appTitle = "Siep | " + routeArray[i].title;
    }
  }
  document.title = appTitle ? appTitle : "Siep | React App";
}

class Content extends React.Component {
  componentDidMount() {
    setTitle(this.props.history.location.pathname, routes);
  }

  componentWillMount() {
    this.props.history.listen(() => {
      setTitle(this.props.history.location.pathname, routes);
    });
  }

  render() {
    const pathname = this.props.location.pathname;
    const isPublicRoute =
      pathname === "/" || pathname.startsWith("/user/") || pathname === "/login-as";

    if (
      localStorage?.my_code &&
      isFreelanceUser() &&
      !isPublicRoute &&
      !isFreelanceRouteAllowed(pathname)
    ) {
      return <Redirect to="/Expedientes" />;
    }

    return (
      <AppSettings.Consumer>
        {({ appContentClass }) => (
          <div className={"app-content " + appContentClass}>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ))}
            <div className="app-footer m-0 ps-5 pe-5 text-end">
              Version 2.0.2
            </div>
          </div>
        )}
      </AppSettings.Consumer>
    );
  }
}

export default withRouter(Content);
